import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { ChatList } from '@widgets/chats/components';

export const Route = createFileRoute('/chats/')({
  component: Component,
});

export default function Component() {
  return (
    <Page hasBackground style={{ padding: '10px 0' }}>
      <ChatList />
    </Page>
  );
}
